<template>
	<div class="row">
		<div class="col-md-8">
			<add-button :onClick="createMilestone" :disabled="isLoading" /> &nbsp;
			<label>Default Payment Term</label>
			<payment-term 
				:initialData="initialData.settings.payment_terms_template"
				:removeMilestone="removeMilestone"
				:isLoading="isLoading" />
		</div>
		<div class="col-md-4">
			<b :class="{'text-red': errors.settings.payment_terms_template}">Total: {{ totalPercent }}%</b>
			<span v-show="errors.settings.payment_terms_template" class="help-block text-red">
				{{ errors.settings.payment_terms_template }}
			</span>
		</div>
		<div class="col-xs-12">
			<input-wrapper id="proposal_terms_template" label="Terms & Conditions">
				<ckeditor 
					id="proposal_terms_template"
					class="form-control"
					v-model="initialData.settings.proposal_terms_template"
					:editor="editor"
					:config="editorConfig"
					:disabled="isLoading" />
			</input-wrapper>
		</div>
	</div>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import AddButton from "../AddButton.vue";
import DeleteButton from "../DeleteButton.vue";
import PaymentTerm from "./PaymentTerm.vue";
import { defaultErrors, defaultFields } from './helpers';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import editorConfig from '../../editor-config';

export default {
	components: {
		AddButton,
		DeleteButton,
		InputWrapper, 
		PaymentTerm,
		ckeditor: CKEditor.component,
	},
	props: {
		totalPercent: {
			type: Number,
			required: true,
		},
		initialData: {
			type: Object,
			default: defaultFields,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		errors: {
			type: Object,
			default: defaultErrors,
		}
	},
	data() {
		return {
			editor: ClassicEditor,
			editorConfig,
		}
	},
	methods: {
		createMilestone() {
			this.initialData.settings.payment_terms_template.push({description: null, percentage: 0});
		},
		removeMilestone(targetIndex) {
			let items = this.initialData.settings.payment_terms_template;
			this.initialData.settings.payment_terms_template = items.filter((item, index) => {
				return index != targetIndex;
			});
		},
	},
}
</script>

<style lang="less" scoped>
.milestone-list {
	list-style-type: none;
}
.milestone-title {
	padding-bottom: 20px;
}
</style>
